module.exports = __webpack_public_path__ + "img/生活英文.92dc7147.png";